import JsonFormatter from "./components/JsonFormatter";

export default function App() {
  return (
    <div className="app">
      <header className="app-header">
        <h1>JSON 格式化工具</h1>
        <p className="app-subtitle">格式化 · 验证 · 结构化展示</p>
      </header>
      <main className="app-main">
        <JsonFormatter />
      </main>
    </div>
  );
}
